const Local = () => {
  const clearLocalStorage = () => {
    window.localStorage.clear();
  }

  const getItem = (itemName, json = false) => {
    if(json){
      return JSON.parse(window.localStorage.getItem(itemName));
    }
    return window.localStorage.getItem(itemName);
  }

  const removeItem = itemName => {
    window.localStorage.removeItem(itemName);
  }

  const setItem = (itemName, itemValue, json = false) => {
    if(json){
      window.localStorage.setItem(itemName, JSON.stringify(itemValue));
    } else {
      window.localStorage.setItem(itemName, itemValue);
    }
  }

  return {
    clearLocalStorage,
    getItem,
    removeItem,
    setItem,
  }
}
export const local = Local();